import request from "./config";

export default class InventoryService {
  static create(data) {
    return request({
      url: "/inventory",
      method: "post",
      data,
    });
  }
  static update(id,data) {
    return request({
      url: `/inventory/${id}`,
      method: "patch",
      data,
    });
  }
  static delete(id) {
    return request({
      url: `/inventory/${id}`,
      method: "delete",
    });
  }
  static  find(params) {
    return request({
      url: `/inventory`,
      method: "get",
      params:params
    });
  }
  static  findReport(params) {
    return request({
      url: `/inventory/report`,
      method: "get",
      params:params
    });
  }
  static  findReportProduct(params) {
    return request({
      url: `/inventory/report/product`,
      method: "get",
      params:params
    });
  }
  static  findLiquidation(params) {
    return request({
      url: `/inventory/liquidation`,
      method: "get",
      params:params
    });
  }
  static  findSummary(params) {
    return request({
      url: `/inventory/summary`,
      method: "get",
      params:params
    });
  }
  static  findStock(params) {
    return request({
      url: `/inventory/stock`,
      method: "get",
      params:params
    });
  }
  static  findOne(params) {
    return request({
      url: `/inventory/verify`,
      method: "get",
      timeout: 100000,
      params:params
    });
  }
}
